<template>
  <tbody class="table-striped">
    <tr>
      <td colspan="2"><strong>{{ productCategory.name }}</strong></td>
      <td class="text-right">
        <a href="#" @click.prevent="$emit('openProducts', {
          warehouse: warehouse.id,
          productCategory: productCategory.id
        })">{{ quantityWithChildren() }}</a>
      </td>
      <td class="text-right">{{ sumEkWithChildren() | priceFromCentEuro }}</td>
      <td class="text-right">{{ sumVkWithChildren() | priceFromCentEuro }}</td>
    </tr>
    <tr v-for="category in childCategoriesToDisplay" :key="category.id">
      <td style="border-right: none;">&nbsp;</td>
      <td style="border-left: none;">{{ category.name }}</td>
      <td class="text-right">
        <a href="#" @click.prevent="$emit('openProducts', {
          warehouse: warehouse.id,
          productCategory: category.id
        })">{{ warehouse.productCategories[category.id].bla_quantity }}</a>
      </td>
      <td class="text-right">{{ warehouse.productCategories[category.id].summe_ek | priceFromCentEuro }}</td>
      <td class="text-right">{{ warehouse.productCategories[category.id].summe_vk | priceFromCentEuro }}</td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: ['productCategory', 'warehouse'],
  computed: {
    childCategoriesToDisplay () {
      return this.productCategory.child_categories.filter(category => this.warehouse.productCategories[category.id])
    }
  },
  methods: {
    quantityWithChildren () {
      let quantity = 0
      if (this.warehouse.productCategories[this.productCategory.id]) {
        quantity = +this.warehouse.productCategories[this.productCategory.id].bla_quantity
      }
      return this.childCategoriesToDisplay.reduce((sum, category) => {
        const childSum = +this.warehouse.productCategories[category.id].bla_quantity
        return sum + childSum
      }, quantity)
    },
    sumEkWithChildren () {
      let categorySum = 0
      if (this.warehouse.productCategories[this.productCategory.id]) {
        categorySum = +this.warehouse.productCategories[this.productCategory.id].summe_ek
      }
      return this.childCategoriesToDisplay.reduce((sum, category) => {
        const childSum = +this.warehouse.productCategories[category.id].summe_ek
        return sum + childSum
      }, categorySum)
    },
    sumVkWithChildren () {
      let categorySum = 0
      if (this.warehouse.productCategories[this.productCategory.id]) {
        categorySum = +this.warehouse.productCategories[this.productCategory.id].summe_vk
      }
      return this.childCategoriesToDisplay.reduce((sum, category) => {
        const childSum = +this.warehouse.productCategories[category.id].summe_vk
        return sum + childSum
      }, categorySum)
    }
  }
}
</script>

<style scoped>
  tbody.table-striped tr:nth-of-type(even) {
    background: rgba(255, 165, 52, 0.1);
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 165, 52, 0.1)), to(rgba(255, 82, 33, 0.1)));
    background: linear-gradient(to bottom, rgba(255, 165, 52, 0.1) 0%, rgba(255, 82, 33, 0.1) 100%);
  }
</style>
